
// export const formatDate = (value: string) => moment(value).format('MMM D, YYYY')


interface FormatAuCurrencyOptions extends Intl.NumberFormatOptions {
  wholeDollars?: boolean;
}

export const formatAuCurrency = (value: number, options?: FormatAuCurrencyOptions) => {
  const {wholeDollars=false, ...passThroughOpts} = options || {};
  return value.toLocaleString('en-AU', {
      style: 'currency', 
      currency: 'AUD', 
      minimumFractionDigits: wholeDollars ? 0 : undefined,
      maximumFractionDigits: wholeDollars ? 0 : undefined,
      ...passThroughOpts
    }
  )}


interface parseAndFormatCurrencyOptions extends FormatAuCurrencyOptions {
  whenInvalid?: string;
}

export const parseAndFormatCurrency = (value: string | number | null | undefined, options?: parseAndFormatCurrencyOptions) : string => {
  
  const {whenInvalid='', ...passThroughOpts} = options || {};
  
  let num: number | null = null;
  if (typeof value === 'string') {
    num = parseFloat(value)
  }
  else if (typeof value === 'number') {
    num = value
  }
  
  if (typeof num === 'number' && !isNaN(num)) {
    return formatAuCurrency(num, passThroughOpts)
  }
  return whenInvalid
}


interface CurrencyProps {
  value: string | number | null | undefined
  wholeDollars?: boolean;
  whenInvalid?: string
}

export const Currency = ({value, ...rest}: CurrencyProps) => <>{parseAndFormatCurrency(value, rest)}</>;
